var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c("h2", { staticClass: "d2-mt-0" }, [
        _vm._v("$route.params.username: " + _vm._s(_vm.$route.params.username))
      ]),
      _c("h2", [
        _vm._v("$route.query.userid: " + _vm._s(_vm.$route.query.userid))
      ]),
      _c("p", [
        _vm._v(
          "你可以尝试返回发送数据页面修改数据重新发送，或者切换到其它页面后刷新浏览器再返回本业观察参数保留"
        )
      ]),
      _c(
        "el-button",
        {
          attrs: { type: "primary" },
          on: {
            click: function($event) {
              return _vm.$router.push({
                name: "demo-playground-page-argu-send"
              })
            }
          }
        },
        [_vm._v("返回发送数据的页面")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }